<template>
  <div class="contacts-list-wrap">
    <ul class="contacts-list" ref="container">
      <li
        class="contacts-list-item"
        v-for="contact in contacts"
        :key="contact.id"
      >
        <div
          class="contacts-list-item-text"
          :class="{ 'text-corpo-l': !isSmall, 'text-corpo-m': isSmall }"
          v-html="contact.text"
        />
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'PagesContactsContactsList',
}
</script>

<script setup>
const props = defineProps({
  contacts: {
    type: Array,
    default: () => [],
  },
  isSmall: {
    type: Boolean,
    default: false,
  },
})

const container = ref(null)

onMounted(() => {
  const contactsContainer = container.value
  const links = contactsContainer.querySelectorAll('a')
  links.forEach((link) =>
    link.classList.add('link-underline-reverse-1', 'click_social'),
  )
})
</script>

<style lang="scss">
@import './style.scss';
</style>
